<div class="menu-bar" *ngrxLet="authStore.isRsaUser() as isRsaUser">
  <div class="menu-btn-container">
    <!-- Control -->
    <button
      *ngIf="installationFeaturesStore.isControlMenuVisible(firstCircuitId) | async"
      mat-button
      class="menu-btn"
      data-at-submenu="control"
      [matMenuTriggerFor]="controlSubMenu"
      gtm="onOpen"
      gtmAction="Control submenu"
      gtmCategory="installationDetailsMenu"
    >
      <span>{{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.CONTROL' | translate }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>
    <mat-menu #controlSubMenu="matMenu">
      <div
        class="holiday-mode-menu-item"
        data-at-submenu-option="holidayProgram"
        *ngIf="installationFeaturesStore.isHolidayModeMenuItemVisible(firstCircuitId) | async"
      >
        <app-set-holiday-mode [circuitId]="firstCircuitId"></app-set-holiday-mode>
      </div>

      <button
        *ngIf="installationFeaturesStore.isSrcMenuItemVisible() | async"
        mat-menu-item
        data-at-submenu-option="src"
        gtm="onOpen"
        gtmAction="Smart Room Control"
        gtmCategory="installationDetailsMenu"
        (click)="
          openSingleRoomControlOverlay(singleRoomControlOverlayTypeEnum.SingleRoomControlDetails)
        "
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.SMART_ROOM_CONTROL.TITLE' | translate }}
      </button>
    </mat-menu>

    <!-- Installation Details -->
    <button
      *ngIf="
        installationFeaturesStore.isInstallationDetailsMenuVisible(gatewaySerial, boilerSerial)
          | async
      "
      mat-button
      class="menu-btn"
      data-at-submenu="installationDetails"
      [matMenuTriggerFor]="installationDetailsSubMenu"
      gtm="onOpen"
      gtmAction="Installation details submenu"
      gtmCategory="installationDetailsMenu"
    >
      <span>{{
        '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.INSTALLATION_DETAILS' | translate
      }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>
    <mat-menu #installationDetailsSubMenu="matMenu">
      <button
        *ngIf="installationFeaturesStore.isControlUnitsMenuItemVisible(boilerSerial) | async"
        mat-menu-item
        data-at-submenu-option="controlUnits"
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.ControlUnits)"
        gtm="onOpen"
        gtmAction="Control Units"
        gtmCategory="installationDetailsMenu"
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.CONTROL_UNITS.TITLE' | translate }}

        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>
    </mat-menu>

    <!-- Documentation -->
    <button
      mat-button
      class="menu-btn"
      data-at-submenu="documentation"
      [matMenuTriggerFor]="documentationSubMenu"
      gtm="onOpen"
      gtmAction="Documentation submenu"
      gtmCategory="installationDetailsMenu"
    >
      <span>{{
        '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.DOCUMENTATION' | translate
      }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>
    <mat-menu #documentationSubMenu="matMenu">
      <button
        data-at-submenu-option="eventLog"
        mat-menu-item
        gtm="onOpen"
        gtmAction="Event log"
        gtmCategory="installationDetailsMenu"
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.EventLog)"
      >
        {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.TITLE' | translate }}
      </button>
      <button
        *ngIf="installationDetailsStore.isMaintenanceChecklistMenuItemVisible() | async"
        data-at-submenu-option="maintenanceChecklist"
        mat-menu-item
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.MaintenanceChecklist)"
        gtm="onOpen"
        gtmAction="Maintenance Checklist"
        gtmCategory="installationDetailsMenu"
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MAINTENANCE_CHECKLIST.TITLE' | translate }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>
      <button
        *ngIf="
          (installationDetailsStore.isServiceInstructionMenuItemVisible() | async) &&
          !(authStore.isDemo$ | async)
        "
        data-at-submenu-option="serviceInstruction"
        mat-menu-item
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.ServiceInstruction)"
        gtm="onOpen"
        gtmAction="Service Instruction"
        gtmCategory="installationDetailsMenu"
      >
        {{ '+INSTALLATIONS.INSTALLATION.SERVICE_INSTRUCTION.TITLE' | translate }}
      </button>
      <button
        *ngIf="installationFeaturesStore.isMaintenanceInformationMenuItemVisible() | async"
        data-at-submenu-option="maintenanceInformation"
        mat-menu-item
        gtm="onOpen"
        gtmAction="Maintenance Information"
        gtmCategory="installationDetailsMenu"
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.MaintenanceInformation)"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.TITLE' | translate }}
      </button>
      <button
        *ngIf="isPowerLimitationHistoryMenuItemVisible$ | async"
        data-at-submenu-option="powerLimitationHistoryLog"
        mat-menu-item
        gtm="onOpen"
        gtmAction="Power Limitation History Log"
        gtmCategory="powerLimitationHistoryLog"
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.PowerLimitationHistoryLog)"
      >
        {{ '+INSTALLATIONS.INSTALLATION.POWER_LIMITATION_HISTORY_LOG.TITLE' | translate }}
      </button>
    </mat-menu>

    <!-- Diagnosis -->
    <button
      *ngIf="installationDetailsStore.isDiagnosisMenuVisible(gatewaySerial) | async"
      mat-button
      class="menu-btn"
      data-at-submenu="diagnosis"
      [matMenuTriggerFor]="diagnosisSubMenu"
      gtm="onOpen"
      gtmAction="Diagnosis submenu"
      gtmCategory="installationDetailsMenu"
    >
      <span>{{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.DIAGNOSIS' | translate }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>

    <mat-menu #diagnosisSubMenu="matMenu">
      <button
        *ngIf="installationDetailsStore.isTrendingMenuItemVisible() | async"
        mat-menu-item
        data-at-submenu-option="trending"
        gtm="onOpen"
        gtmAction="Data Trending"
        gtmCategory="installationDetailsMenu"
        (click)="openOverlay(featuresDetailsOverlayTypeEnum.Trending)"
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.DATA_TRENDING.TITLE' | translate }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>
      <button
        mat-menu-item
        data-at-submenu-option="permanentInspection"
        gtm="onOpen"
        gtmAction="Permanent Inspection"
        gtmCategory="installationDetailsMenu"
        *ngIf="installationDetailsStore.isPermanentInspectionMenuItemVisible() | async"
        (click)="openRemoteInspectionOverlay()"
        class="menu-item"
      >
        {{
          '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.PERMANENT_INSPECTION.TITLE' | translate
        }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>

      <div
        class="diagnostic-mode-block"
        *ngIf="
          (installationDetailsStore.isSnapshotMenuItemVisible(gatewaySerial) | async) ||
          (installationDetailsStore.isExtendedParametersMenuItemVisible(gatewaySerial) | async) ||
          (installationDetailsStore.isBackupMenuItemVisible(gatewaySerial) | async)
        "
      >
        <div class="diagnostic-mode-features-txt">
          {{
            '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.DIAGNOSTIC_MODE_FEATURES.TITLE'
              | translate
          }}
        </div>
        <div class="divider"></div>
      </div>

      <button
        mat-menu-item
        data-at-submenu-option="diagnostics"
        gtm="onOpen"
        gtmAction="Remote diagnostics modal"
        gtmCategory="installationDetailsMenu"
        (click)="openDiagnosticsOverlay(diagnosticsOverlayTypeEnum.ExtendedParameter)"
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.EXTENDED_PARAMETERS.TITLE' | translate }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>

      <button
        mat-menu-item
        data-at-submenu-option="snapshot"
        gtm="onOpen"
        gtmAction="Snapshot"
        gtmCategory="installationDetailsMenu"
        (click)="openDiagnosticsOverlay(diagnosticsOverlayTypeEnum.DiagnosisSnapshots)"
        *ngIf="
          (installationDetailsStore.isSnapshotMenuItemVisible(gatewaySerial) | async) &&
          (installationDetailsStore.isSelectedGatewayAV2Cascade$ | async) === false
        "
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.SNAPSHOT.TITLE' | translate }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>

      <button
        *ngIf="installationDetailsStore.isBackupMenuItemVisible(gatewaySerial) | async"
        mat-menu-item
        data-at-submenu-option="backup"
        gtm="onOpen"
        gtmAction="Backup & Restore"
        gtmCategory="installationDetailsMenu"
        (click)="openDiagnosticsOverlay(diagnosticsOverlayTypeEnum.DiagnosisBackupAndRestore)"
        class="menu-item"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.DIAGNOSIS.BACKUP.TITLE' | translate }}
        <span class="pro-label">
          {{ '+BOOKING.PLAN.PRO_PACKAGE' | translate }}
        </span>
      </button>
    </mat-menu>

    <!-- Firmware Update -->
    <button
      *ngIf="
        (firmwareUpdateStore.isFirmwareUpdateButtonAvailable$ | async) &&
        !(authStore.isDemo$ | async)
      "
      mat-button
      class="menu-update-btn"
      gtm="onOpen"
      gtmAction="Firmware update"
      gtmCategory="installationDetailsMenu"
      (click)="openFirmwareUpdateDialog()"
    >
      {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.FIRMWARE_UPDATE' | translate }}
    </button>

    <!-- Partner access / commercial -->
    <button
      *ngIf="installationDetailsStore.isPartnerAccessMenuVisible() | async"
      mat-button
      class="menu-btn"
      gtm="onOpen"
      gtmAction="Partner access submenu"
      gtmCategory="installationDetailsMenu"
      data-at-submenu="partnerAccess"
      [matMenuTriggerFor]="partnerAccessSubMenu"
    >
      <span>{{
        '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.PARTNER_ACCESS' | translate
      }}</span>
      <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
    </button>

    <mat-menu #partnerAccessSubMenu="matMenu">
      <button
        mat-menu-item
        data-at-submenu-option="settings"
        gtm="onOpen"
        gtmAction="Partner access overlay"
        gtmCategory="installationDetailsMenu"
        (click)="openPartnerAccessOverlay(partnerAccessOverlayTypeEnum.Settings)"
      >
        {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.PARTNER_ACCESS.SETTINGS.TITLE' | translate }}
      </button>
    </mat-menu>

    <!-- Service layer-->
    <button
      *ngIf="
        (installationDetailsStore.isServiceLayerButtonVisible$ | async) &&
        !(authStore.isDemo$ | async)
      "
      mat-button
      class="menu-update-btn"
      gtm="onOpen"
      gtmAction="Service layer overlay"
      gtmCategory="installationDetailsMenu"
      (click)="openOverlay(featuresDetailsOverlayTypeEnum.ServiceLayer)"
    >
      {{ '+INSTALLATIONS.INSTALLATION.MENU_BAR.MENU_SECTION.SERVICE_LAYER' | translate }}
    </button>
  </div>
</div>
